export default "__VITE_ASSET__CjfUvPaS__"